import React from "react";
import { Outlet } from "react-router-dom";
import { Button } from "@heroui/button";
import { Moon, Sun } from "lucide-react";

import { useTheme } from "../../context/ThemeContext";

const AuthLayout: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div
      className={`min-h-screen flex bg-gray-100 dark:bg-gray-900 ${theme === "dark" ? "dark" : ""}`}
    >
      {/* Theme toggle in top corner */}
      <div className="absolute top-4 right-4">
        <Button
          isIconOnly
          aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
          className="bg-white dark:bg-gray-800 shadow-sm"
          variant="light"
          onPress={toggleTheme}
        >
          {theme === "light" ? (
            <Moon className="w-5 h-5" />
          ) : (
            <Sun className="w-5 h-5" />
          )}
        </Button>
      </div>

      {/* Left side - Brand image/background */}
      <div className="hidden md:block md:w-1/2 bg-primary-600 flex items-center justify-center relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-400 to-primary-700 opacity-90" />
        <div className="relative z-10 p-12 text-white max-w-md">
          <img
            alt="Enzo's Restaurant"
            className="h-16 mb-8"
            src="/logo-white.svg"
          />
          <h1 className="text-4xl font-bold mb-4">
            Enzo's Restaurant Management System
          </h1>
          <p className="text-xl mb-8">
            Streamline your restaurant operations with our comprehensive
            management platform.
          </p>
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-white/20 backdrop-blur-sm p-4 rounded-lg">
              <div className="text-3xl font-bold mb-1">24/7</div>
              <div className="text-sm">Real-time order tracking</div>
            </div>
            <div className="bg-white/20 backdrop-blur-sm p-4 rounded-lg">
              <div className="text-3xl font-bold mb-1">+30%</div>
              <div className="text-sm">Increase in efficiency</div>
            </div>
            <div className="bg-white/20 backdrop-blur-sm p-4 rounded-lg">
              <div className="text-3xl font-bold mb-1">-15%</div>
              <div className="text-sm">Reduction in waste</div>
            </div>
            <div className="bg-white/20 backdrop-blur-sm p-4 rounded-lg">
              <div className="text-3xl font-bold mb-1">+25%</div>
              <div className="text-sm">Customer satisfaction</div>
            </div>
          </div>
        </div>

        {/* Abstract patterns */}
        <div className="absolute bottom-0 left-0 w-full h-64 bg-gradient-to-t from-primary-800 to-transparent opacity-30" />
        <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full opacity-10 -mr-32 -mt-32" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full opacity-10 -ml-48 -mb-48" />
      </div>

      {/* Right side - Auth form */}
      <div className="w-full md:w-1/2 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
